import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

export default function FormatoVacaciones({ usuario, onBackToMenu }) {
  const [datosEmpleado, setDatosEmpleado] = useState({
    nombres: '',
    documento: '',
    cargo: 'Cargando...',
    centroTrabajo: ''
  });

  const [formData, setFormData] = useState({
    fechaDeseada: "",
    periodoCausado: "",
    diasTomar: "",
    observaciones: ""
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // 1. Tomamos el usuario global pasado por props (o del localStorage)
    const userStorage = JSON.parse(localStorage.getItem("usuario") || localStorage.getItem("userData") || "{}");
    const userData = usuario || userStorage;
    const token = localStorage.getItem("token");

    const docReal = String(userData.documento || userData.cedula || '').trim();
    const nombreReal = String(userData.nombres || userData.nombre || userData.terc_nom || '').trim();
    const centroReal = String(userData.centroTrabajo || userData.centro_trabajo || userData.sede || userData.area_nombre || '').trim();
    let cargoReal = String(userData.cargo || userData.empl_cargo || 'Sin cargo asignado').trim();
    
    if (cargoReal === 'SUPER_ADMIN') cargoReal = 'Administrador del Sistema';

    setDatosEmpleado({
      nombres: nombreReal,
      documento: docReal,
      cargo: cargoReal,
      centroTrabajo: centroReal
    });

    const fetchPerfilReal = async () => {
      try {
        if (!docReal) return; 
        const API_URL = process.env.REACT_APP_API_URL;
        const res = await fetch(`${API_URL}/api/empleados/${docReal}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (res.ok) {
          const data = await res.json();
          if (data.success && data.empleado) {
            setDatosEmpleado(prev => ({
              ...prev,
              cargo: data.empleado.cargo || prev.cargo
            }));
          }
        }
      } catch (error) {
        console.error("Error obteniendo cargo de BD");
      }
    };

    fetchPerfilReal();
  }, [usuario]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!datosEmpleado.documento) {
        return Swal.fire({
            icon: 'error',
            title: 'Error de Sesión',
            text: 'No se detectó su número de documento. Por favor, cierre sesión y vuelva a ingresar.',
            confirmButtonColor: '#ef4444'
        });
    }

    if (!formData.fechaDeseada || !formData.diasTomar || !formData.periodoCausado) {
      return Swal.fire({
        icon: 'warning',
        title: 'Campos Incompletos',
        text: 'Por favor complete todos los campos obligatorios.',
        confirmButtonColor: '#3b82f6'
      });
    }

    setLoading(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const token = localStorage.getItem("token");

      // PAYLOAD EXACTO: Mapeado 1 a 1 con las columnas de tu base de datos
      const payload = {
        documento: datosEmpleado.documento,
        nombres: datosEmpleado.nombres,
        cargo: datosEmpleado.cargo,
        centro_trabajo: datosEmpleado.centroTrabajo,
        fecha_deseada: formData.fechaDeseada,
        periodo_causado: formData.periodoCausado,
        dias_tomar: Number(formData.diasTomar),
        observaciones: formData.observaciones || ""
      };

      const res = await fetch(`${API_URL}/api/th/vacaciones`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }) 
        },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Vacaciones Radicadas',
          text: 'Su solicitud FOR-TH-99 ha sido radicada con éxito para aprobación.',
          confirmButtonColor: '#3b82f6'
        });
        setFormData({ fechaDeseada: "", periodoCausado: "", diasTomar: "", observaciones: "" });
      } else {
        throw new Error('Error en el backend al guardar');
      }

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error de Conexión',
        text: 'No se pudo radicar la solicitud. Intente nuevamente.',
        confirmButtonColor: '#ef4444'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-50/80 backdrop-blur-3xl p-6 sm:p-10 rounded-[32px] shadow-sm border border-white w-full max-w-4xl mx-auto animate-fade-in-up">
      
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 pb-6 border-b border-gray-200 gap-4">
        <div>
          <span className="text-[10px] font-bold bg-blue-100 text-blue-700 px-3 py-1 rounded-full uppercase">FOR-TH-99 (Versión 02)</span>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight mt-1">🏖️ Solicitud y Programación de Vacaciones</h2>
          <p className="text-sm text-gray-500 font-medium mt-1">El Gran Surtidor - Subproceso Gestión de Personal.</p>
        </div>
        <button 
          type="button"
          onClick={onBackToMenu} 
          className="px-5 py-2.5 text-xs font-bold bg-white text-slate-800 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors shadow-sm"
        >
          Volver
        </button>
      </div>

      <div className="bg-white/60 backdrop-blur-md p-5 rounded-2xl border border-gray-200 mb-6 grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs shadow-sm">
        <div>
          <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Colaborador:</span>
          <span className="font-extrabold text-blue-900 text-sm uppercase">{datosEmpleado.nombres || 'No detectado'}</span>
        </div>
        <div>
          <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Documento:</span>
          <span className="font-extrabold text-blue-900 text-sm">{datosEmpleado.documento || 'No detectado'}</span>
        </div>
        <div>
          <span className="block text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Cargo:</span>
          <span className="font-extrabold text-blue-900 text-sm uppercase">{datosEmpleado.cargo}</span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        
        <div className="bg-white/60 p-4 rounded-2xl border border-gray-200 text-xs text-gray-700 italic shadow-sm">
          "Atentamente solicito se sirvan programar y liquidar las vacaciones a que tengo derecho de acuerdo con las especificaciones relacionadas a continuación:"
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Fecha que desea disfrutar (Sujeto a aprobación):</label>
            <input 
              type="date" 
              name="fechaDeseada"
              value={formData.fechaDeseada} 
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-2xl px-4 py-3 text-sm font-bold text-gray-900 focus:outline-none focus:border-blue-500 shadow-sm"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Período Causado:</label>
            <input 
              type="text" 
              name="periodoCausado"
              value={formData.periodoCausado} 
              onChange={handleChange} 
              placeholder="2024 - 2025"
              className="w-full bg-white border border-gray-200 rounded-2xl px-4 py-3 text-sm font-bold text-gray-900 focus:outline-none focus:border-blue-500 shadow-sm"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Número de días hábiles a tomar:</label>
          <input 
            type="number" 
            name="diasTomar"
            min="1" 
            max="30" 
            value={formData.diasTomar} 
            onChange={handleChange} 
            placeholder="15"
            className="w-full sm:w-1/2 bg-white border border-gray-200 rounded-2xl px-4 py-3 text-sm font-bold text-gray-900 focus:outline-none focus:border-blue-500 shadow-sm"
            required
          />
        </div>

        <div>
          <label className="block text-xs font-bold text-gray-700 uppercase mb-2">Observaciones:</label>
          <textarea 
            rows="3" 
            name="observaciones"
            value={formData.observaciones} 
            onChange={handleChange} 
            placeholder="Escriba alguna observación adicional si lo requiere..."
            className="w-full bg-white border border-gray-200 rounded-2xl px-4 py-3 text-sm font-medium text-gray-900 focus:outline-none focus:border-blue-500 shadow-sm"
          ></textarea>
        </div>

        <div className="flex justify-end pt-4">
          <button 
            type="submit" 
            disabled={loading}
            className="px-8 py-3.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-extrabold rounded-full shadow-md transition-all cursor-pointer disabled:opacity-50"
          >
            {loading ? "Enviando solicitud..." : "📤 Radicar Solicitud de Vacaciones"}
          </button>
        </div>

      </form>
    </div>
  );
}